import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import ArmaTable from './components/ArmaTable';
import ArmaToolbar from './components/ArmaToolbar/ArmaToolbar';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { NotFound as NotFoundView } from '../index';
import { MessageValues } from '../../values/MessageValues';
import { isAuthenticated } from '../../helpers/authenticate';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  divFab:{
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));
function ArmaList({history}) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [armas, setArmas] = useState({
    result: []
  });
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [showDialogConfirmacaoDeleteArma, setShowDialogConfirmacaoDeleteArma] = useState(false);
  const [selectedIndexArma, setSelectedIndexArma] = useState(-1);
  const [cnpjConfirmation, setCnpjConfirmation] = useState('');
  const [sucess, setSucess] = useState(true);
  const [openArmaChangePassword, setOpenArmaChangePassword] = useState(false);
  const [armaSelecionado, setArmaSelecionado] = useState({});

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    async function carregarArmas() {
      try{
        setLoading(true);
        const params = {
          limit: 100,
        };
        const dados = await api.get('armas/', {params: params});
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length !== 0){
            for(let i = 0, size = dados.data.result.length; i < size; i++){
              dados.data.result[i].on_mouse_over = false;
            }
            setArmas(dados.data);
          }
          else{
            setLoading(false);
            setTypeSnack('warning');
            setMessageSnack('Não há armas cadastradas');
            setShowMessageSnack(true);
          }
        }
        else{
          setSucess(false);
        }

      }
      catch (e) {
        setSucess(false);

      }
    }
    carregarArmas();
  }, []);

  function showConfirmationDeleteArma(index){
    if (selectedIndexArma < 0 && selectedIndexArma >= armas.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o usuário');
      setShowMessageSnack(true);
    }
    else{
      setSelectedIndexArma(index);
      setShowDialogConfirmacaoDeleteArma(true);
    }

  }

  async function deleteArma() {
    if (selectedIndexArma < 0 && selectedIndexArma >= armas.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o arma');
      setShowMessageSnack(true);
    }
    else{
      try {
        setShowDialogConfirmacaoDeleteArma(false);
        setLoading(true);
        const id = armas.result[selectedIndexArma].idArma;
        const dados = await api.delete(`armas/${id}`);
        setCnpjConfirmation('');
        if (dados.data.isSuccess === true) {
          const params = {
            limit: 100,
          };
          const dados = await api.get('armas/', { params: params });
          setLoading(false);
          if (dados.data.isSuccess === true) {
            setTypeSnack('success');
            setMessageSnack('Arma deletado com sucesso');
            setShowMessageSnack(true);
            for (let i = 0, size = dados.data.result.length; i < size; i++) {
              dados.data.result[i].on_mouse_over = false;
            }
            setArmas(dados.data);
          } else {
            setTypeSnack('error');
            setMessageSnack('Erro ao carregar armas');
            setShowMessageSnack(true);
          }
        } else {
          setTypeSnack('error');
          setMessageSnack('Erro ao deletar arma. Contate o suporte.');
          setShowMessageSnack(true);
        }

      } catch (e) {
        setCnpjConfirmation('');
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
        setShowMessageSnack(true);
      }

    }
  }

  function onCancelDeleteArma() {
    setSelectedIndexArma(-1);
    setShowDialogConfirmacaoDeleteArma(false)
  }

  async function filterArmas(filterValue) {
    try {
      setLoading(true);
      const params = {
        descricao: filterValue,
        numeroArma: filterValue
      };
      const dados = await api.get('armas/filter', { params: params });
      setLoading(false);
      if (dados.data.isSuccess) {
        for (let i = 0, size = dados.data.result.length; i < size; i++) {
          dados.data.result[i].on_mouse_over = false;
        }
        setArmas(dados.data);
      } else {
      }

    } catch (e) {
      console.log(e.toString())
    }
  }

  function openArmaRegister() {
    const arma = {
      descricao: '',
      numeroArma: '',
      numeroNotaFiscal: '',
      idCalibre: ''
    };
    history.push('/arma-register/', {arma: arma, edicao: false});
  }

  async function openArmaEdit(index) {
    try{
      if (index < 0 && index >= armas.result.length) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Não foi possível editar a arma');
        setShowMessageSnack(true);
      } else {
        setLoading(true);
        const dados = await api.get(`armas/${armas.result[index].idArma}`);
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length > 0){
            history.push('/arma-edit/', {arma: dados.data.result[0], edicao: true});
          }
          else{
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack('Ocorreu um erro ao obter dados da arma.');
            setShowMessageSnack(true);
          }
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Ocorreu um erro ao obter dados da arma.');
          setShowMessageSnack(true);
        }
      }
    }
    catch (e) {
      setSucess(false);
    }
  }

  return (
    sucess
    ?
      <div
        className={classes.root}
      >
        <ArmaToolbar
          filterArmas={filterArmas}
        />
        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
        <Dialog open={showDialogConfirmacaoDeleteArma} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Remoção de arma</DialogTitle>
          <DialogContent>
            <Typography gutterBottom>
              Você está tentando deletar uma arma com as seguintes informações:
            </Typography>
            <Typography
              gutterBottom
              style={{marginTop: '30px'}}
            >
              {selectedIndexArma < 0 || selectedIndexArma >= armas.result.length ? '' :
                'Descricao: ' + armas.result[selectedIndexArma].descricao
              }
            </Typography>
            <Typography
              gutterBottom

            >
              {selectedIndexArma < 0 || selectedIndexArma >= armas.result.length ? '' :
                'Número: ' + armas.result[selectedIndexArma].numeroArma
              }
            </Typography>
            <Typography
              gutterBottom
              style={{marginBottom: '30px'}}
            >
              {selectedIndexArma < 0 || selectedIndexArma >= armas.result.length ? '' :
                'Calibre: ' + armas.result[selectedIndexArma].calibre.descricao
              }
            </Typography>
            <Typography gutterBottom>
              Tem certeza que deseja excluir essa arma?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancelDeleteArma} color="primary">
              Cancelar
            </Button>
            <Button onClick={deleteArma} color="primary">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
        <div className={classes.content}>
          <ProgressFullScreen
            open={loading}
            setOpen={setLoading}
          />
          <ArmaTable
            armas={armas}
            setArmas={setArmas}
            deleteArma={showConfirmationDeleteArma}
            editArma={openArmaEdit}
            showMessageSnack={showMessageSnack}
            setShowMessageSnack={setShowMessageSnack}
            messageSnack={messageSnack}
            setMessageSnack={setMessageSnack}
            typeSnack={typeSnack}
            setTypeSnack={setTypeSnack}
          />
        </div>
        <div
          className={classes.divFab}

        >
          <Fab
            aria-label={'Add'}
            className={classes.fab}
            color={'primary'}
            variant={'round'}
            onClick={openArmaRegister}
          >
            <AddIcon />
          </Fab>
        </div>
      </div>
      :
      <NotFoundView/>

  );
};

export default ArmaList;
